import axios from "axios";
import store from "../redux-store/store";
import { logoutUser } from "redux-store/auth/actions";
import { handleUnAuthorizedAction } from "redux-store/auth/reducers";
import { decide401 } from "api/session";
import { replayWithCurrentToken } from "api/replay";
import { resolveTenantSubdomain } from "config/tenancy";

function getSubdomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  // Assuming your main domain has two parts (e.g., example.com)
  // Adjust the number `2` if your main domain is different (e.g., example.co.uk would need `3`)
  if (parts.length > 2) {
    return parts[0];
  }
  return null;
}

export const setAxios = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
  axios.defaults.headers.common["Content-Type"] = "application/json";

  const hostSubdomain = getSubdomain();
  // On a non-tenant host (backoffice, app, account, www) the tenant stored
  // from the login response wins — see config/tenancy.
  const subdomain = resolveTenantSubdomain(hostSubdomain, localStorage._subdomain);

  if (subdomain) {
    axios.defaults.headers.common["_subdomain"] = subdomain;
  }

  axios.interceptors.request.use(
    (config) => {
      if (localStorage.authToken) config.headers.Authorization = `Bearer ${localStorage.authToken}`;
      const requestSubdomain = resolveTenantSubdomain(hostSubdomain, localStorage._subdomain);
      if (requestSubdomain) config.headers._subdomain = `${requestSubdomain}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (result) => {
      return result;
    },
    async (error) => {
      // Same rule as the api/ instances: only flex2-api's user-info 401 ends
      // the session; any other 401 re-checks it first, and a dead session is
      // renewed once and the call replayed before signing out (api/session).
      const verdict = error?.response?.status === 401 ? await decide401(error) : "keep";
      if (verdict === "retry") return replayWithCurrentToken(error.config);
      if (verdict === "signout") {
        localStorage?.clear();
        store.dispatch(logoutUser());
        store.dispatch(handleUnAuthorizedAction(true));
      }
      return Promise.reject(error);
    }
  );
};
